import {
  Wallet,
  Calendar,
  Stethoscope,
  Clock,
  TrendingUp,
  Shield,
} from "lucide-react";

const benefits = [
  {
    icon: Wallet,
    title: "Ca. 30€ pro Spende",
    description:
      "Erhalten Sie eine Aufwandsentschädigung für jede Plasmaspende. Durch Aktionen und Boni ist oft mehr möglich!",
    gradient: "from-primary/20 to-accent/10",
  },
  {
    icon: Calendar,
    title: "Bis zu 60 Spenden innerhalb von 12 Monaten",
    description:
      "Das ist eine mögliche Höchstzahl, keine allgemeine Empfehlung. Die tatsächliche Häufigkeit hängt von der individuellen Eignung, Proteinregeneration und weiteren Spenden ab.",
    gradient: "from-accent/20 to-primary/10",
  },
  {
    icon: Stethoscope,
    title: "Medizinische Prüfung vor jeder Spende",
    description:
      "Vor jeder Spende prüft das medizinische Personal anhand Ihrer Angaben und erforderlicher Untersuchungen, ob Sie aktuell spenden können.",
    gradient: "from-bonus/20 to-accent/10",
  },
  {
    icon: Clock,
    title: "30–55 Minuten reine Spende",
    description:
      "Die eigentliche Spende dauert je nach Anbieter etwa 30–55 Minuten. Für den regulären Besuch kommt Zeit für Anmeldung, Untersuchung und Erholung hinzu.",
    gradient: "from-primary/20 to-bonus/10",
  },
  {
    icon: TrendingUp,
    title: "Attraktive Bonusprogramme",
    description:
      "Neuspender erhalten bei CSL Plasma und Plasma Service Europe einen attraktiven Anmeldebonus und Sonderboni.",
    gradient: "from-bonus/20 to-primary/10",
  },
  {
    icon: Shield,
    title: "Medizinisch begleitet",
    description:
      "Die Spende erfolgt unter medizinischer Aufsicht. Die Eignung wird vor jeder Spende individuell beurteilt.",
    gradient: "from-accent/20 to-bonus/10",
  },
];

const Benefits = () => {
  return (
    <section
      className="section-screen bg-background scroll-mt-20 md:scroll-mt-0"
      id="vorteile"
      aria-labelledby="benefits-heading"
    >
      <div className="container container-narrow">
        <h2
          id="benefits-heading"
          className="text-3xl md:text-4xl font-bold text-center mb-4 font-display"
        >
          <span className="text-foreground">Vorteile der </span>
          <span className="text-gradient">Plasmaspende</span>
        </h2>
        <p className="text-muted-foreground text-center mb-12 max-w-xl mx-auto text-lg">
          Mit Ihrer Plasmaspende retten Sie Leben und profitieren gleichzeitig
          von vielen Vorteilen
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <div key={index} className="card-modern p-6 group">
              <div className="w-14 h-14 rounded-2xl icon-glow flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                <benefit.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="font-bold text-lg mb-3 text-foreground">
                {benefit.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed text-sm">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
